module.exports = __webpack_public_path__ + "img/MapPicsDuelingIslands.ec8c8415.webp";